import type { Inspection } from '../types';

const INSPECTIONS_KEY = 'treadai_inspections';

export const saveInspection = (inspection: Inspection): void => {
  const inspections = getInspections();
  const updated = [inspection, ...inspections.filter((i) => i.id !== inspection.id)];
  localStorage.setItem(INSPECTIONS_KEY, JSON.stringify(updated));
};

export const getInspections = (): Inspection[] => {
  try {
    const data = localStorage.getItem(INSPECTIONS_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

export const getInspectionById = (id: string): Inspection | null => {
  const inspections = getInspections();
  return inspections.find((i) => i.id === id) || null;
};

export const deleteInspection = (id: string): void => {
  const inspections = getInspections();
  const updated = inspections.filter((i) => i.id !== id);
  localStorage.setItem(INSPECTIONS_KEY, JSON.stringify(updated));
};

export const seedInspections = (): void => {
  const existing = getInspections();
  if (existing.length > 0) return;

  const seedData: Inspection[] = [
    {
      id: 'seed-001',
      createdAt: new Date(Date.now() - 86400000 * 2).toISOString(),
      vehicle: {
        vin: '1HGCM82633A004352',
        plate: '8ABC123',
        make: 'Honda',
        model: 'Civic',
        year: 2019,
      },
      tires: [
        {
          position: 'FL',
          tread_mm: 5.2,
          wear_pattern: 'even',
          dot_code: 'DOT U2LL LMLR 3218',
          age_years: 3.5,
          status: 'ok',
        },
        {
          position: 'FR',
          tread_mm: 5.0,
          wear_pattern: 'even',
          dot_code: 'DOT U2LL LMLR 3218',
          age_years: 3.5,
          status: 'ok',
        },
        {
          position: 'RL',
          tread_mm: 4.8,
          wear_pattern: 'even',
          dot_code: 'DOT U2LL LMLR 3218',
          age_years: 3.5,
          status: 'ok',
        },
        {
          position: 'RR',
          tread_mm: 4.9,
          wear_pattern: 'even',
          dot_code: 'DOT U2LL LMLR 3218',
          age_years: 3.5,
          status: 'ok',
        },
      ],
      overallStatus: 'ok',
      recommendations: [
        'All tires are in good condition. Continue regular maintenance and inspections.',
      ],
    },
    {
      id: 'seed-002',
      createdAt: new Date(Date.now() - 86400000 * 7).toISOString(),
      vehicle: {
        vin: '5TDJKRFH9FS095302',
        plate: 'XYZ789',
        make: 'Toyota',
        model: 'Highlander',
        year: 2015,
      },
      tires: [
        {
          position: 'FL',
          tread_mm: 2.8,
          wear_pattern: 'inner_edge',
          dot_code: 'DOT MA L9 AOR 1015',
          age_years: 7.2,
          status: 'replace_soon',
        },
        {
          position: 'FR',
          tread_mm: 2.9,
          wear_pattern: 'inner_edge',
          dot_code: 'DOT MA L9 AOR 1015',
          age_years: 7.2,
          status: 'replace_soon',
        },
        {
          position: 'RL',
          tread_mm: 3.5,
          wear_pattern: 'even',
          dot_code: 'DOT MA L9 AOR 1015',
          age_years: 7.2,
          status: 'unsafe',
        },
        {
          position: 'RR',
          tread_mm: 3.4,
          wear_pattern: 'even',
          dot_code: 'DOT MA L9 AOR 1015',
          age_years: 7.2,
          status: 'unsafe',
        },
      ],
      overallStatus: 'unsafe',
      recommendations: [
        'Replace RL, RR tire(s) - age exceeds 6 years, beyond recommended limit.',
        'Schedule replacement soon for FL, FR tire(s) - tread depth below 3.0mm.',
        'Uneven wear detected on FL, FR tire(s) - check alignment, tire pressure, and suspension.',
      ],
    },
    {
      id: 'seed-003',
      createdAt: new Date(Date.now() - 86400000 * 14).toISOString(),
      vehicle: {
        vin: '1FTFW1ET5EFC10312',
        plate: 'TRK456',
        make: 'Ford',
        model: 'F-150',
        year: 2021,
      },
      tires: [
        {
          position: 'FL',
          tread_mm: 7.2,
          wear_pattern: 'even',
          dot_code: 'DOT H8 JR XX3X 4520',
          age_years: 1.8,
          status: 'ok',
        },
        {
          position: 'FR',
          tread_mm: 7.0,
          wear_pattern: 'even',
          dot_code: 'DOT H8 JR XX3X 4520',
          age_years: 1.8,
          status: 'ok',
        },
        {
          position: 'RL',
          tread_mm: 6.8,
          wear_pattern: 'even',
          dot_code: 'DOT H8 JR XX3X 4520',
          age_years: 1.8,
          status: 'ok',
        },
        {
          position: 'RR',
          tread_mm: 6.9,
          wear_pattern: 'even',
          dot_code: 'DOT H8 JR XX3X 4520',
          age_years: 1.8,
          status: 'ok',
        },
      ],
      overallStatus: 'ok',
      recommendations: [
        'All tires are in good condition. Continue regular maintenance and inspections.',
      ],
    },
  ];

  localStorage.setItem(INSPECTIONS_KEY, JSON.stringify(seedData));
};
